import { BaseResponse } from '../../../../../../types/api/api.types';
import { COMPANY_ENDPOINTS } from '../../../../../../utils/api/endpoints/companyEndpoints';
import { ProfileCompanyFormSchema } from './ProfileCompanyForm.types';

const PREFIX = '[createPendingCompanyQuery]';

export const CREATE_PENDING_COMPANY_QUERY_KEY = 'CREATE_PENDING_COMPANY';

export const createPendingCompanyQuery = async (data: ProfileCompanyFormSchema) => {
  console.log(PREFIX, `Requesting user account update...`);

  const response = await COMPANY_ENDPOINTS.createPending(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account update response.`);
  return json as BaseResponse;
};
